const FacebookLogin = (props) => (
  <svg
    id={props.id}
    style={props.styles}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
    fill="none"
    className={props.className}
  >
    <title>{props.title || "Facebook"}</title>
    <path
      d="M19.4368 10C19.4368 4.47715 15.0857 0 9.7184 0C4.35107 0 0 4.47715 0 10C0 14.9912 3.55386 19.1283 8.1999 19.8785V12.8906H5.73234V10H8.1999V7.79688C8.1999 5.29063 9.65082 3.90625 11.8707 3.90625C12.934 3.90625 14.0461 4.10156 14.0461 4.10156V6.5625H12.8207C11.6135 6.5625 11.2369 7.3334 11.2369 8.12422V10H13.9322L13.5014 12.8906H11.2369V19.8785C15.8829 19.1283 19.4368 14.9912 19.4368 10Z"
      fill={props.fill || "#1877F2"}
    />
  </svg>
);

export default FacebookLogin;
